if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.prefetchCache = new Map();
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper?.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';

      this.addEventListener('mousedown', (e) => {
        if (e.target.tagName === 'LABEL') {
          const scrollY = window.scrollY;
          requestAnimationFrame(() => window.scrollTo({ top: scrollY, behavior: 'instant' }));
        }
      });
    }

    connectedCallback() {
      
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.prefetchProductUrls();

      //自定义badge的显示
      this.initVariantBadges();
      this.updateOptionBadges();
    }

    onVariantChange() {
      this.updateOptions();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      this.renderVariantInfo();

      this.updateOther();

      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section,
        variantTitle: this.options.join(' / ')
      });

      this.updateOptionBadges();
    }

    //自定义初始化badge
    initVariantBadges() {
      const script = document.getElementById(`VariantBadges-${this.dataset.section}`);
      this.variantBadges = script? JSON.parse(script.textContent) : [];
    }

    //更新选项的badge
    updateOptionBadges() {
      if (!this.variantBadges.length) return;
      // 删除旧 badge
      this.querySelectorAll(".variant-badge").forEach(el => el.remove());
      this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
      this.fieldsets.forEach((fieldset, optionIndex) => {

        const optionName = fieldset.dataset.handle;
        fieldset.querySelectorAll("input").forEach(input => {

          const label = fieldset.querySelector(`label[for="${input.id}"]`);
          if (!label) return;


          /**
          * 1. 图片 badge
          * Option Value 级别
          *
          * 只匹配：
          * option_name + 当前 option value
          *
          * 不判断其它 option
          */
          const imageBadge = this.variantBadges.find(item => {
            if (!item.badge_image)
              return false;

            if (item.option_name !== optionName)
              return false;

            return item[`option${optionIndex + 1}`] === input.value;
          });

          /**
          * 2. 文字 badge
          * Variant 级别
          *
          * 必须匹配完整 variant
          */
          const textBadge = this.variantBadges.find(item => {

            if (!item.badge_text)
              return false;

            if (item.option_name !== optionName)
              return false;

            // 当前 option value
            if (item[`option${optionIndex + 1}`] !== input.value)
              return false;

            // 其它 option 必须匹配当前选择
            for (let i = 0; i < this.options.length; i++) {
              if (i === optionIndex)
                continue;
              if (item[`option${i + 1}`] !== this.options[i])
                return false;
            }
            return true;
          });
          
          let html = "";
          // Option badge 图片
          if (imageBadge) {
            html += `
              <span class="variant-badge variant-badge-image text-${imageBadge.badge_alignment || "right"}">
                <img 
                  class="badge-image"
                  src="${imageBadge.badge_image}"
                  alt=""
                  loading="lazy">
              </span>
            `;
          }
          // Variant badge 文案
          if (textBadge) {
            html += `
              <span class="variant-badge variant-badge-text text-${textBadge.badge_alignment || "right"}">
                <span class="text">
                  ${textBadge.badge_text}
                </span>
              </span>
            `;
          }
          if (html) {
            label.insertAdjacentHTML("afterbegin", html);
          }
        });
      });
    }


    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      const span = this.querySelector(`#SelectedVariant-${this.dataset.section}`);
      if (!span) return;
      this.currentVariant = {
        id: parseInt(span.dataset.variantId, 10) || null,
        available: span.dataset.available === 'true',
        featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
      };
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);
      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');
      pickUpAvailability?.update(this.currentVariant);
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    getSelectedValueIds() {
      return this.fieldsets.map((fieldset) => {
        if (fieldset.querySelector('select')) {
          return fieldset.querySelector('select').selectedOptions[0]?.dataset.valueId;
        }
        return fieldset.querySelector('input:checked')?.dataset.valueId;
      }).filter(Boolean);
    }

    renderVariantInfo() {
      // Combined listings: check if selected options point to a different product
      const productUrl = this.getProductUrl();
      if (productUrl) {
        this.switchProduct(productUrl);
        return;
      }

      const ids = this.getSelectedValueIds();
      if (!ids.length) return;

      const scrollY = window.scrollY;

      fetch(`${this.dataset.url}?option_values=${ids.join(',')}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          // 1. Resolve variant from hidden span
          const span = html.getElementById(`SelectedVariant-${this.dataset.section}`);

          // Combined listings server-side fallback: if response product differs from current
          if (span && span.dataset.productUrl && span.dataset.productUrl !== this.dataset.url) {
            this.switchProduct(span.dataset.productUrl);
            return;
          }
          if (span && parseInt(span.dataset.variantId, 10)) {
            this.currentVariant = {
              id: parseInt(span.dataset.variantId, 10),
              available: span.dataset.available === 'true',
              featured_media: span.dataset.featuredMediaId ? { id: parseInt(span.dataset.featuredMediaId, 10) } : null
            };
          } else {
            this.currentVariant = null;
          }

          // 2. Sync data-available onto current DOM inputs (drives setDisabled)
          const sourceSelects = html.getElementById(`variant-selects-${this.dataset.section}`);
          if (sourceSelects) {
            sourceSelects.querySelectorAll('[data-value-id]').forEach((sourceEl) => {
              const vid = sourceEl.dataset.valueId;
              const avail = sourceEl.dataset.available;
              [this, ...this.other].forEach((el) => {
                const localEl = el.querySelector(`[data-value-id="${vid}"]`);
                if (localEl) localEl.dataset.available = avail;
              });
            });
          }

          // 3. Update price, inventory, sku sections
          this.getSectionsToRender().forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            if (id.includes('price') && destination) destination.classList.remove('visibility-hidden');
          });

          // Update Pickup Availability
          this.updatePickupAvailability();

          // 4. Apply updated state
          if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
            window.scrollTo({ top: scrollY, behavior: 'instant' });
            return;
          }
          this.setDisabled();
          this.updateVariantInput();
          if (this.updateUrl) this.updateURL();
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          this.updateMedia();
          window.scrollTo({ top: scrollY, behavior: 'instant' });
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const buyButtons = document.querySelectorAll('.single-buy-it-now-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.dataset.content = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.dataset.content = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.dataset.content = window.theme.variantStrings.addToCart;
          }
        }
      });


      //新增buy it now的逻辑
      if (!buyButtons) return;

      buyButtons.forEach((buyButton) => {
        const buyButtonText = buyButton.querySelector('.single-buy-it-now-button--text');

        if (!buyButtonText) return;

        if (disable) {
          buyButton.setAttribute('disabled', 'disabled');
          if (text) buyButtonText.dataset.content = text;
        } else {
          buyButton.removeAttribute('disabled');
          buyButton.classList.remove('loading');
          buyButtonText.dataset.content = window.theme.variantStrings.buyNow;
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.dataset.content = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') return;

      this.fieldsets.forEach((fieldset) => {
        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach((opt) => {
            opt.disabled = opt.dataset.available === 'false';
          });
        } else {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.classList.toggle('is-disabled', input.dataset.available === 'false');
          });
        }
      });
      return true;
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;

        this.setImageSetMedia();
      }
    }
    prefetchProductUrls() {
      var productUrlElements = this.querySelectorAll('[data-product-url]');
      var currentUrl = this.dataset.url;
      var sectionId = this.dataset.section;
      var cache = this.prefetchCache;

      productUrlElements.forEach(function (el) {
        var productUrl = el.dataset.productUrl;
        if (!productUrl || productUrl === currentUrl) return;
        if (cache.has(productUrl)) return;

        var hoverTarget;
        if (el.tagName === 'OPTION') {
          hoverTarget = el.closest('select');
        } else {
          hoverTarget = el.parentElement.querySelector('label[for="' + el.id + '"]') || el;
        }

        hoverTarget.addEventListener('mouseenter', function () {
          if (cache.has(productUrl)) return;
          fetch(productUrl + '?section_id=' + sectionId)
            .then(function (response) { return response.text(); })
            .then(function (html) {
              cache.set(productUrl, html);
            })
            .catch(function () { });
        }, { once: true });
      });
    }

    getProductUrl() {
      var currentUrl = this.dataset.url;

      for (var i = 0; i < this.fieldsets.length; i++) {
        var fieldset = this.fieldsets[i];
        var productUrl = null;

        if (fieldset.querySelector('select')) {
          var selectedOption = fieldset.querySelector('select').selectedOptions[0];
          productUrl = selectedOption ? selectedOption.dataset.productUrl : null;
        } else {
          var checkedInput = fieldset.querySelector('input:checked');
          productUrl = checkedInput ? checkedInput.dataset.productUrl : null;
        }

        if (productUrl && productUrl !== currentUrl) {
          return productUrl;
        }
      }
      return null;
    }

    switchProduct(productUrl) {
      var sectionId = this.dataset.section;
      var scrollY = window.scrollY;

      var applyHtml = function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var newSection = html.getElementById('shopify-section-' + sectionId);

        if (!newSection) return;

        var currentSection = document.getElementById('shopify-section-' + sectionId);
        if (!currentSection) return;

        currentSection.innerHTML = newSection.innerHTML;
        window.history.replaceState({}, '', productUrl);
        window.scrollTo({ top: scrollY, behavior: 'instant' });
      };

      if (this.prefetchCache.has(productUrl)) {
        applyHtml(this.prefetchCache.get(productUrl));
        return;
      }

      fetch(productUrl + '?section_id=' + sectionId)
        .then(function (response) { return response.text(); })
        .then(function (responseText) {
          applyHtml(responseText);
        });
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      const optionPosition = parseInt(this.imageSetIndex.replace('option', ''), 10) - 1;
      const fieldset = this.fieldsets[optionPosition];
      if (!fieldset) return;
      const select = fieldset.querySelector('select');
      const checked = fieldset.querySelector('input:checked');
      let setValue;
      if (select && select.selectedOptions[0]) {
        setValue = select.selectedOptions[0].dataset.handle;
      } else if (checked) {
        setValue = checked.dataset.handle;
      }
      if (!setValue) return;
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.quickView = this.closest('#Product-Drawer-Content');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      this.progress_bar = this.product_container.querySelector('.flickity-progress--bar');
      this.tabs_container = this.product_container.querySelector('.product-media-tabs');//获取切换按钮

        this.setOptions();
      // Defer Flickity init to next frame — avoids forced reflow during DOM parsing
      requestAnimationFrame(() => this.init());
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.tabs = this.tabs_container?.querySelectorAll('.media-tab'); //自定义tab切换
      this.images = this.querySelectorAll('img');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        cellAlign: this.quickView ? 'left' : 'right',
        adaptiveHeight: !this.quickView,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        rightToLeft: document.dir === 'rtl',
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        on: {
          ready: () => {
            this.images.forEach((img) => {
              img.addEventListener('lazyloaded', () => {
                this.flkty.resize();
              });
            });
          },
          dragStart: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none");
          },
          dragEnd: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all");
          }
        }
      };
      if (this.quickView) {
        this.options.wrapAround = false;
      }
      if (this.progress_bar) {
        this.options.on.scroll = (progress) => {
          progress = Math.max(0, Math.min(1, progress));
          this.progress_bar.style.width = progress * 100 + '%';
        };
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          document.dir === 'rtl' ? this.flkty.next() : this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          document.dir === 'rtl' ? this.flkty.next() : this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          document.dir === 'rtl' ? this.flkty.previous() : this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          document.dir === 'rtl' ? this.flkty.previous() : this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media');

        //获取现在的媒体
        let current_slide = this.flkty.cells[index].element,
          current_media = current_slide.querySelector('.product-single__media');

        if (this.thumbnails) {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
            active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

          this.thumbnails.forEach((item, i) => {
            item.classList.remove('is-initial-selected');
          });
          active_thumb.classList.add('is-initial-selected');

          requestAnimationFrame(() => {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
              top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
              behavior: 'smooth'
            });
          });
        }

         //传事件给gtm
        const product_container = this.quickView ? 'Quick Product' : 'Main Product';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'product_image_swipe',
          slideIndex: index + 1,
          slideContainer: product_container
        });

         //自定义tab
       if (this.tabs) {
          const matchedTab = Array.from(this.tabs).find(tab => {
            const tabIndex = parseInt(tab.getAttribute('data-media-index'), 10);
            const mediaIndex = isNaN(tabIndex) ? 0 : tabIndex - 1;
            return mediaIndex === index;
          });

          if (matchedTab) {
            const activeTab = Array.from(this.tabs).find(tab => tab.classList.contains('is-active'));

            if (activeTab && activeTab !== matchedTab) {
              activeTab.classList.remove('is-active');
              matchedTab.classList.add('is-active');
            }
            if (!activeTab) {
              matchedTab.classList.add('is-active');
            }
          }
        }


        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          const auto_pre_video = previous_media.querySelector('video.autoplay-video');//设置只有不是自动播放的才需要暂停
          if(!auto_pre_video){
            previous_media.querySelector('video').pause();
          }
        }

          //渲染现在的slide的视频
        if(current_media.classList.contains('product-single__media-native-video')) {
          const template = current_media.querySelector('.background-video__deferred');
            if (template) {
              const clone = template.content.cloneNode(true);
              template.replaceWith(clone);

              const video = current_media.querySelector('video');

               const poster = video.poster;

              if (poster) {
                video.poster = '';
                video.poster = poster;
              }
          }
        }

      });

      if (this.thumbnails && !this.thumbnail_container.dataset.init) {
        setTimeout(() => {
          let active_thumbs = this.hide_variants ?
            Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')) :
            Array.from(this.thumbnails);
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
          this.thumbnail_container.addEventListener('click', (e) => {
            let count = Math.min(Math.max(this.thumbnail_container.querySelectorAll('.is-active').length, 1), 4);
            this.thumbnail_container.style.setProperty('--thumbnail-width', (count * 63) + 19 + 'px');
            if (!this.thumbnail_container.classList.contains('extended')) {
              this.thumbnail_container.classList.add('extended');
            } else {
              if (e.target.nodeName == 'BUTTON') {
                this.thumbnail_container.classList.remove('extended');
              }
              e.preventDefault();
            }
            if (!this.thumbnail_container.classList.contains('extended')) {
              let active_thumb = this.thumbnail_container.querySelector('.is-initial-selected');
              setTimeout(() => {
                active_thumb.parentElement.scrollTo({
                  left: Math.max(active_thumb.offsetLeft, 0),
                  top: 0,
                  behavior: 'smooth'
                });
              }, 300);
            }
          });
          this.thumbnail_container.dataset.init = true;
        });
      }

      /* tabs切换事件 */
      if (this.tabs) {
        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            this.tabs.forEach(t => t.classList.remove('is-active'));
            tab.classList.add('is-active');   
            const selectedTabIndex = tab.getAttribute('data-media-index');
            const selectedIndex = !isNaN(selectedTabIndex)?parseInt(selectedTabIndex, 10) - 1:0;
            if (!isNaN(selectedIndex)) {
              this.flkty.select(selectedIndex);
            }
          });
        });
      }

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();

      document.addEventListener('product:variant-change', (e) => {
        if (e.detail && e.detail.variantTitle && e.detail.variantTitle !== 'Default Title') {
          this.dataset.variantTitle = e.detail.variantTitle;
        }
      });
    }
    buildItems() {
      this.imageToSlideMap = [];//创建

      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item, imageIndex) => {
        /* 
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);*/

        /* 优化替换原来获取index的方式，获取实际的对应的index */
        const slide = item.closest('.product-images__slide');
        const slideIndex = Array.from(slide.parentNode.children).indexOf(slide);
        this.imageToSlideMap[imageIndex] = slideIndex;


        let activelink = item.querySelector('.product-single__media-zoom');

        /*activelink.dataset.index = index;*/
        activelink.dataset.index = imageIndex;

        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          thumbSrc: activelink.dataset.thumbSrc || activelink.dataset.msrc
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: true,
        allowPanToNext: true,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    buildPswpThumbnails(items) {
      const container = this.pswpElement.querySelector('.pswp__thumbs-inner');
      if (!container) return;
      container.innerHTML = '';
      if (this.dataset.lightboxThumbnails === 'false' || items.length <= 1) {
        container.parentElement.style.display = 'none';
        return;
      }
      container.parentElement.style.display = '';
      items.forEach((item, index) => {
        const thumb = document.createElement('div');
        thumb.className = 'pswp__thumb';
        thumb.dataset.index = index;
        const img = document.createElement('img');
        img.src = item.thumbSrc;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
        container.appendChild(thumb);
      });
    }
    updatePswpProductInfo() {
      const infoEl = this.pswpElement.querySelector('.pswp__product-info');
      if (!infoEl) return;
      if (this.dataset.lightboxProductInfo === 'false') {
        infoEl.style.display = 'none';
        return;
      }
      infoEl.style.display = '';
      const titleEl = infoEl.querySelector('.pswp__product-title');
      const variantEl = infoEl.querySelector('.pswp__variant-title');
      if (titleEl) titleEl.textContent = this.dataset.productTitle || '';
      if (variantEl) variantEl.textContent = this.dataset.variantTitle || '';
    }
    syncPswpThumbnails(index) {
      const container = this.pswpElement.querySelector('.pswp__thumbs-inner');
      if (!container) return;
      const thumbs = container.querySelectorAll('.pswp__thumb');
      thumbs.forEach((t, i) => {
        t.classList.toggle('is-active', i === index);
      });
      const activeThumb = container.querySelector('.pswp__thumb.is-active');
      if (activeThumb) {
        activeThumb.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
      }
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        this.buildPswpThumbnails(this.items);
        this.updatePswpProductInfo();

        // Prevent touch/mouse events on bottom bar from reaching PhotoSwipe's gesture handler
        const bottomBar = this.pswpElement.querySelector('.pswp__bottom-bar');
        if (bottomBar) {
          ['mousedown', 'touchstart', 'pointerdown'].forEach(evtName => {
            bottomBar.addEventListener(evtName, (evt) => evt.stopPropagation());
          });
        }

        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        const _this = this;

        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 140
            };
          });
        });

        // Reset any accidental parent scroll caused by loop transition
        const scrollWrap = this.pswpElement.querySelector('.pswp__scroll-wrap');
        const resetScroll = function () {
          if (scrollWrap) scrollWrap.scrollLeft = 0;
          _this.pswpElement.scrollLeft = 0;
        };

        pswp.listen('beforeChange', function () {
          const index = pswp.getCurrentIndex();
          _this.syncPswpThumbnails(index);
          resetScroll();
          // Sync product slideshow with lightbox
          /*
          if (_this.flkty) {
            _this.flkty.select(index);
          }*/
          //优化点击切换的放大图和轮播图对应关系
          const slideIndex = _this.imageToSlideMap[index];
          if (slideIndex !== undefined) {
            _this.flkty.select(slideIndex);
          }
        });

        const thumbsInner = this.pswpElement.querySelector('.pswp__thumbs-inner');
        if (thumbsInner) {
          thumbsInner.addEventListener('click', function handler(evt) {
            evt.stopPropagation();
            const thumb = evt.target.closest('.pswp__thumb');
            if (thumb) {
              pswp.goTo(parseInt(thumb.dataset.index, 10));
              resetScroll();
            }
          });
        }

        pswp.listen('close', function () {
          const container = _this.pswpElement.querySelector('.pswp__thumbs-inner');
          if (container) container.innerHTML = '';
        });

        pswp.init();
        this.syncPswpThumbnails(this.pswpOptions.index);
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      /* 自定义buy now按钮 */
      const isAddToCart = evt.submitter?.classList.contains('single-add-to-cart-button');
      const isBuyNow = evt.submitter?.classList.contains('single-buy-it-now-button');
      // ✅ 非自己按钮直接放行（dynamic checkout）
      if (!isAddToCart && !isBuyNow) return;
      // ⚠️ 只拦截自己的按钮
      evt.preventDefault();
      // --- 判断按钮类型，如果是buy now，直接跳转到结账页
      if (isBuyNow) {
        const formData = new FormData(this.form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
          },
          body: formData
        })
        .then(async (response) => {
          const result = await response.json().catch(() => null);

          if (!response.ok) {
            console.error('加购失败：', response.status, result);
            return;
          }

          window.location.assign('/checkout');
        })
        .catch((err) => {
          console.error('加购请求失败：', err);
        });

        return;
      }



      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
          if (document.querySelector('.product-add-to-cart-sticky-modal')) {
            document.querySelector('.product-add-to-cart-sticky-modal').removeAttribute('open');
          }
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer'),
        cart_drawer = document.getElementById('Cart-Drawer');

      if (search_drawer && OverlayManager.isOpen(search_drawer)) {
        OverlayManager.close(search_drawer);
      }
      if (cart_drawer) {
        cart_drawer.notesToggle();
        cart_drawer.discountToggle();
        cart_drawer.updateFreeShipping();
      }
      if (product_drawer && product_drawer.contains(this)) {
        OverlayManager.close(product_drawer);
        if (cart_drawer) {
          OverlayManager.open(cart_drawer, ['open-cart']);
        }
      } else if (cart_drawer) {
        OverlayManager.open(cart_drawer, ['open-cart']);
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupObservers();
      this.drawer = document.getElementById(this.dataset.target);
      this.addEventListener('click', this.onClick.bind(this));
    }
    onClick() {
      this.drawer.show();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}


/*自定义表格部分隐藏显示*/

if (!customElements.get('expandable-table')) {
  class ExpandableTable extends HTMLElement {
    connectedCallback() {
      const rowsVisible = 4;
      const table = this.querySelector('table');
      if (!table) return;

      const tbody = table.querySelector('tbody');
      if (!tbody) return;

      const rows = Array.from(tbody.querySelectorAll('tr'));
      let expanded = false;

      // 获取除表格外的其他所有元素（排除 <table>）
      const otherElements = Array.from(this.children).filter(el => el !== table);

      // 创建按钮 wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'button-wrapper';

      // 创建按钮
      const toggleBtn = document.createElement('button');
      toggleBtn.textContent = 'View More';
      toggleBtn.className = 'text-button product-details-view-more';

      wrapper.appendChild(toggleBtn);

      // 初始隐藏表格超出部分行
      rows.forEach((row, index) => {
        if (index >= rowsVisible) row.classList.add('collapsed-row');
      });

      // 初始隐藏其他内容
      otherElements.forEach(el => el.classList.add('collapsed-content'));

      toggleBtn.addEventListener('click', () => {
        expanded = !expanded;

        // 切换表格多余行
        rows.forEach((row, index) => {
          if (index >= rowsVisible) {
            row.classList.toggle('collapsed-row', !expanded);
          }
        });

        // 切换其他内容显示隐藏
        otherElements.forEach(el => {
          el.classList.toggle('collapsed-content', !expanded);
        });

        toggleBtn.textContent = expanded ? 'View Less' : 'View More';
      });

      this.insertAdjacentElement('afterend', wrapper);
    }
  }

  customElements.define('expandable-table', ExpandableTable);
}

/** 自定义sticky add to cart */
if (!customElements.get('add-to-cart-sticky')) {
class AddToCartSticky extends HTMLElement {
  connectedCallback() {
    const target = document.querySelector(".product-information--inner .product-add-to-cart-container");
    if (!target) return;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle("active", !entry.isIntersecting);
      },
      {
        threshold: 0,
      }
    );

    this.observer.observe(target);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define("add-to-cart-sticky", AddToCartSticky);
}


/* 产品页锚点导航 */
if (!customElements.get('top-navigation')) {
  customElements.define(
    'top-navigation',
    class TopNavigation extends HTMLElement {
      constructor() {
        super();

        this.mediaQuery = window.matchMedia('(max-width: 767px)');
        this.lastScrollTop = window.scrollY;
        this.isManualScroll = false;
        this.scrollTimeout = null;

        this.handleScroll = this.scrollListener.bind(this);
        this.handleInputClick = this.handleInputClick.bind(this);
        this.handleMediaQueryChange =
          this.handleMediaQueryChange.bind(this);
      }

      connectedCallback() {
        this.handleMediaQueryChange();
        this.mediaQuery.addEventListener(
          'change',
          this.handleMediaQueryChange
        );
      }

      handleMediaQueryChange() {
        if (this.mediaQuery.matches) {
          this.bindMobileEvents();
          this.updateActiveSection();
        } else {
          this.unbindMobileEvents();
          this.resetRadioState();
          this.hideSticky();
        }

        this.lastScrollTop = window.scrollY;
      }

      bindMobileEvents() {
        this.navInputs = this.querySelectorAll('input[type="radio"]');

        this.navInputs.forEach((input) => {
          input.addEventListener('click', this.handleInputClick);
        });

        window.addEventListener('scroll', this.handleScroll, {
          passive: true
        });
      }

      unbindMobileEvents() {
        this.navInputs?.forEach((input) => {
          input.removeEventListener('click', this.handleInputClick);
        });

        window.removeEventListener('scroll', this.handleScroll);
        clearTimeout(this.scrollTimeout);
      }

      handleInputClick(e) {
        const section = document.querySelector(
          `[data-tab="${e.currentTarget.id}"]`
        );

        if (!section) return;

        this.isManualScroll = true;
        section.scrollIntoView({ behavior: 'smooth' });

        clearTimeout(this.manualScrollTimeout);
        this.manualScrollTimeout = setTimeout(() => {
          this.isManualScroll = false;
        }, 1000);
      }

      updateActiveSection() {
        if (!this.mediaQuery.matches || this.isManualScroll) return;

        const threshold = window.innerHeight * 0.3;

        const matchedSections = Array.from(
          document.querySelectorAll('[data-tab^="top-navigation"]')
        ).filter((section) => {
          const rect = section.getBoundingClientRect();

          return (
            rect.top <= threshold &&
            rect.bottom >= threshold
          );
        });

        if (!matchedSections.length) {
          this.resetRadioState();
          return;
        }

        // 如果多个嵌套区域同时命中，优先选择最内层
        const activeSection = matchedSections.reduce(
          (deepestSection, currentSection) => {
            if (deepestSection.contains(currentSection)) {
              return currentSection;
            }

            return deepestSection;
          }
        );

        const radio = document.getElementById(
          activeSection.dataset.tab
        );

        if (radio) {
          radio.checked = true;
        }
      }


      scrollListener() {
        if (!this.mediaQuery.matches) return;

        const currentScroll = window.scrollY;

        const targetSection = document.querySelector(
          '.product-information'
        );

        if (targetSection) {
          const targetTop =
            targetSection.getBoundingClientRect().top +
            currentScroll;

          const stickyPoint = targetTop - 160;

          if (currentScroll >= stickyPoint) {
            this.showSticky();
          } else {
            this.hideSticky();
          }
        }

        this.lastScrollTop = currentScroll;

        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          this.updateActiveSection();
        }, 100);
      }

      showSticky() {
        this.classList.add('top-nav-sticky');
      }

      hideSticky() {
        this.classList.remove('top-nav-sticky');
      }

      resetRadioState() {
        this.querySelectorAll('input[type="radio"]').forEach(
          (input) => {
            input.checked = false;
          }
        );
      }

      disconnectedCallback() {
        this.unbindMobileEvents();

        this.mediaQuery.removeEventListener(
          'change',
          this.handleMediaQueryChange
        );

        clearTimeout(this.manualScrollTimeout);
      }
    }
  );
}



/*
*自定义移动评论模块位置
*/
 document.addEventListener('DOMContentLoaded', function () {
    const reviews = document.getElementById('judgeme_product_reviews');

    if (!reviews) return;

    function moveReviews() {
      const screenWidth = window.innerWidth;

      if (screenWidth < 768) {
        // 移动到移动端容器
        const mobileTarget = document.querySelector('#mobile-review-container');
        if (mobileTarget && !mobileTarget.contains(reviews)) {
          mobileTarget.appendChild(reviews);
        }
      } else {
        // 移动回桌面端容器
        const desktopTarget = document.querySelector('#desktop-review-container');
        if (desktopTarget && !desktopTarget.contains(reviews)) {
          desktopTarget.appendChild(reviews);
        }
      }
    }

    moveReviews();
    window.addEventListener('resize', moveReviews);
  });

/* information的text根据同组优先级比较，高的显示，低的隐藏。 */
  document.querySelectorAll('.product-information').forEach((container) => {
  const blocks = Array.from(
    container.querySelectorAll('.product--text')
  );

  const groups = {};

  blocks.forEach((block) => {
    const group = block.dataset.group;

    if (!groups[group]) {
      groups[group] = [];
    }

    groups[group].push(block);
  });

  Object.values(groups).forEach((groupBlocks) => {
    const priorities = groupBlocks.map((block) =>
      Number(block.dataset.priority || 0)
    );

    const maxPriority = Math.max(...priorities);

    // 最高优先级有多个时，全部显示
    groupBlocks.forEach((block) => {
      const priority = Number(block.dataset.priority || 0);

      block.hidden = priority < maxPriority;
    });
  });
});
